import { ISO_DATE_FORMAT, paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'
import maDate from '@/base/MaDate.js'
import Device from '@/base/constants/Device.js'

export function getTopApps({ store, countryCode, device = Device.Iphone, category, rankingType }, optionalParams) {
  if (optionalParams && optionalParams.date) {
    optionalParams.date = maDate(optionalParams.date).format(ISO_DATE_FORMAT)
  }
  return makeRequest(`/categoryrankings/topapps/${store}/${category}/${countryCode}/${rankingType.toUpperCase()}?device=${device}&${paramsToQuery(optionalParams)}`)
}

export function getNewApps({ store, categoryId, countryCode, rankingType }, optionalParams) {
  return makeRequest(`/categoryrankings/newapps/${store}/${categoryId}/${countryCode}/${rankingType.toUpperCase()}?${paramsToQuery(optionalParams)}`)
}

/**
 * Returns sorting category ranking between given date and its previous day as descending.
 * @param {string} changeType - movers or losers
 * @param {string} store - play or ios
 * @param {string} categoryId - 36 means all iOS apps
 * @param {string} countryCode - Country Code (US,TR, BE etc.)
 * @param {string} rankingType - FREE, PAID, or GROSSING
 * @param {string} device - android, iphone, or ipad
 * @param {string} date - selected date as ISODateString
 * @return {Promise<any>} Promise<any>
 */
export function getTopAppsByNormalSort({ changeType, store, categoryId, countryCode, rankingType, device, date }) {
  return makeRequest(`/categoryrankings/topapps/${changeType}/${store}/${categoryId}/${countryCode}/${rankingType}?device=${device}&date=${date}`)
}

/**
 * Smart Sort is based on MobileAction's own calculation&sorting algorithm.
 * Returns sorting category ranking between given firstDate and secondDate as descending.
 * @param {string} changeType - movers or losers
 * @param {string} store - play or ios
 * @param {string} categoryId - 36 means all iOS apps
 * @param {string} countryCode - Country Code (US,TR, BE etc.)
 * @param {string} rankingType - FREE, PAID, or GROSSING
 * @param {string} device - android, iphone, or ipad
 * @param {string} firstDate - selected first date as ISODateString
 * @param {string} secondDate - selected second date as ISODateString
 * @return {Promise<any>} Promise<any>
 */
export function getTopAppsBySmartSort({ changeType, store, categoryId, countryCode, rankingType, device, firstDate, secondDate }) {
  return makeRequest(`/categoryrankings/topapps/smart/${changeType}/${store}/${categoryId}/${countryCode}/${rankingType}?device=${device}&firstDate=${firstDate}&secondDate=${secondDate}`)
}
